<div class="row">
	<div class="col-6" *ngIf="isHideColums">
		<p style="margin: 0px; padding: 0px; font-size: 11px">Hide Columns (Click on the column You want to See):</p>

		<p>
			<span *ngFor="let thead of theads" class="badge bg-primary"  [ngClass]="{ hidden: thead.visible }">
				{{ thead.text }}
			</span>
		</p>
	</div>
	<div class="col-6" *ngIf="!isHideColums"></div>
	<div class="col-2" *ngIf="isPagination">
		Quantity per page
		<select [(ngModel)]="paginacion.cantidad" (change)="imprimirPaginacion()" class="form-control paginacion">
			<option value="10">10</option>
			<option value="25">25</option>
			<option value="50">50</option>
			<option value="100">100</option>
			<option value="500">500</option>
			<option value="1000">1000</option>
		</select>
	</div>
	<div class="col-2" *ngIf="isPagination">
		Page
		<select [(ngModel)]="paginacion.pagina" (change)="imprimirPaginacion()" class="form-control paginacion">
			<option value="{{ num + 1 }}" *ngFor="let i of paginacion.totalPag; let num = index">
				{{ num + 1 }}
			</option>
		</select>
	</div>
	<div class="col-4" *ngIf="!isPagination"></div>
	<div class="col-2 mt-2" align="right" style="padding-bottom: 0px; padding-top: 12px">
		<button type="button" class="btn btn-success btn-label waves-effect waves-light" (click)="exportExcel('tableToExport')">
			<i class="ri-file-excel-fill label-icon align-middle fs-16 me-2"></i>
			Export
		</button>
	</div>
</div>
<div class="row">
	<div class="col-12 table-responsive">
		<table id="tableToExport" class="table align-middle mb-0 mt-3">
			<thead class="{{ tableConfig.theadClass }} table-light">
				<tr>
					<th *ngIf="count">#</th>
					<th *ngIf="activation">Active</th>
					<th *ngFor="let thead of theads; let i = index" class="{{ thead.thead_class }} {{ thead.align }} {{ thead.width }}" [ngClass]="{ hidden: !thead.visible }">
						<span style="cursor: pointer">{{ thead.text }} </span>
						<i *ngIf="thead.order != ''" class="fa fa-sort-{{ thead.order }}" aria-hidden="true"></i>
						<i class="ri-close-line" aria-hidden="true" (click)="thead.visible = false" style="margin-left: 5px; cursor: pointer; font-size: 10px"></i>
					</th>
					<th *ngIf="buttons.length > 0" align="center"></th>
					<th *ngIf="icons" align="center" class="tcol-30" width="30%"></th>
				</tr>
			</thead>
			<tbody *ngIf="paginacion.showData.length > 0">
				<tr *ngFor="let row of paginacion.showData; let dataI = index" [ngClass]="{ dblClick: tableConfig.dblclickRows }" (dblclick)="handleDblClick(row)">
					<td *ngIf="count" class="center">
						{{ dataI + 1 + paginacion.cantidad * paginacion.pagina - paginacion.cantidad }}
					</td>
					<td *ngIf="activation" align="center">
						<div class="form-check form-switch">
							<input *ngIf="row['isActive'] == 1" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" checked (click)="toogleActive(row, 0)" />

							<input *ngIf="row['isActive'] == 0" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" (click)="toogleActive(row, 1)" />
						</div>

						<!-- <i *ngIf="row['isActive'] == 1" (click)="toogleActive(row, 0)"
							class="fa fa-lg fa-check-square-o" style="cursor:pointer"></i> -->
						<!-- <i *ngIf="row['isActive'] == 0" (click)="toogleActive(row, 1)" class="fa fa-lg fa-square-o"
							style="cursor:pointer"></i> -->
					</td>
					<td
						*ngFor="let thead of theads; let i = index"
						class="text-dark {{ thead.width }} {{ thead.align }}"
						[ngClass]="{
							hidden: !thead.visible,
							'bg-success': row.class && row.class.class === 'bg-success' && isChangeColor(thead),
							'bg-grey-dark': row.class && row.class.class === 'bg-grey-dark' && isChangeColor(thead),
							'bg-grey-light': row.class && row.class.class === 'bg-grey-light' && isChangeColor(thead),
							'bg-purple': row.class && row.class.class === 'bg-purple' && isChangeColor(thead),
							'bg-purple-light': row.class && row.class.class === 'bg-purple-light' && isChangeColor(thead),
							'bg-info': row.class && row.class.class === 'bg-infor' && isChangeColor(thead),
							'bg-danger': row.class && row.class.class === 'bg-danger' && isChangeColor(thead),
							'bg-warning': row.class && row.class.class === 'bg-warning' && isChangeColor(thead),
							'bg-info': row.class && row.class.class === 'bg-info' && isChangeColor(thead),
							'bg-oliva': row.class && row.class.class === 'bg-oliva' && isChangeColor(thead),
							'bg-grey-dark': thead.class && thead.class.class === 'bg-grey-dark' && isChangeColor(thead),
							't3-blue-bg': thead.key === 'name' || thead.key === 'leads_needed',
							'callback-date-col': thead.key === 'callbacks'
						}"
					>
						<span *ngIf="thead.type == 'string' || thead.type == '' || thead.type == 'number'"><i class="{{ thead.icon }}" *ngIf="thead.icon"></i> {{ row[thead.key] != "0" ? row[thead.key] : "-" }}</span>
						<span *ngIf="thead.type == 'mediumDate' || thead.type == 'short' || thead.type == 'medium'"><i class="{{ thead.icon }}" *ngIf="thead.icon"></i> {{ row[thead.key] | utcToLocal : thead.type }}</span>
						<span *ngIf="thead.type == 'currency' && row[thead.key] != 0"><i class="{{ thead.icon }}" *ngIf="thead.icon"></i> {{ row[thead.key] | currency : USD }}</span>
						<span *ngIf="thead.type == 'currency' && row[thead.key] == 0"
							><i class="{{ thead.icon }}" *ngIf="thead.icon"></i>
							-
						</span>
						<span *ngIf="thead.type == 'dateAgo'"><i class="{{ thead.icon }}" *ngIf="thead.icon"></i> {{ row[thead.key] | dateAgo }}</span>
						<div id="test" *ngIf="thead.type == 'HTML'" [innerHTML]="row[thead.key]"></div>
					</td>
					<td *ngIf="buttons.length > 0" align="center">
						<button *ngFor="let btn of buttons" (click)="pressButton(row, btn.text)" class="btn btn-{{ btn.color }} btn-{{ btn.size }}">
							{{ btn.text }}
						</button>
					</td>
					<td *ngIf="icons" align="center">
						<button *ngFor="let icon of row.icons" (click)="pressIcon(row, icon.action)" type="button" class="btn {{ icon.color }} btn-icon waves-effect waves-light" style="margin: 0 5px" ngbTooltip="{{ icon.tooltip }}" placement="top">
							<i class="{{ icon.name }}"></i>
						</button>

						<!-- <i *ngFor="let icon of row.icons" (click)="pressIcon(row, icon.action)" class="{{icon.name}}"
							style="cursor:pointer"></i> -->
					</td>
				</tr>
				<tr *ngIf="totales" class="table-light align-middle">
					<td *ngIf="count" class="center"></td>
					<td *ngIf="activation" class="center"></td>
					<td *ngFor="let total of totalRow; let i = index" align="center">
						<strong *ngIf="total.type === 'currency' && total.value != 'Totals'">{{ total.value | currency : USD }}</strong>
						<strong *ngIf="total.type === 'number' && total.value != 'Totals'">{{ total.value | number : "1.2-2" }}</strong>
						<strong *ngIf="total.type === 'total' && total.value != 'Totals'">{{ total.value | number : "1.2-2" }}</strong>
					</td>
					<td *ngIf="icons" class="center"></td>
				</tr>
			</tbody>
		</table>
		<div align="center" *ngIf="paginacion.showData.length < 1">No records available</div>
	</div>
</div>
